import { useQuery } from '@tanstack/react-query'
import { useNetworkEnvironment } from '@/hooks/useNetworkEnvironment'
import { monitoringService } from '@/services/admin/monitoringService'

export const queueQuarantineQueryKeys = {
  list: (mode: string, params: Record<string, unknown>) => [
    'admin',
    'queue-quarantine',
    'list',
    mode,
    params,
  ] as const,
  statistics: (mode: string) => [
    'admin',
    'queue-quarantine',
    'statistics',
    mode,
  ] as const,
  sourceQueues: (mode: string) => [
    'admin',
    'queue-quarantine',
    'source-queues',
    mode,
  ] as const,
}

export function useQueueQuarantineMessages(
  params: {
    limit?: number
    offset?: number
    status?: string
    queue?: string
  },
  options?: { enabled?: boolean }
) {
  const { currentEnv } = useNetworkEnvironment()
  return useQuery({
    queryKey: queueQuarantineQueryKeys.list(currentEnv, params),
    queryFn: () => monitoringService.getQueueQuarantineMessages(params, currentEnv),
    enabled: options?.enabled ?? true,
    staleTime: 0,
  })
}

export function useQueueQuarantineStatistics(options?: { enabled?: boolean }) {
  const { currentEnv } = useNetworkEnvironment()
  return useQuery({
    queryKey: queueQuarantineQueryKeys.statistics(currentEnv),
    queryFn: () => monitoringService.getQueueQuarantineStatistics(currentEnv),
    enabled: options?.enabled ?? true,
    refetchInterval: options?.enabled === false ? false : 30_000,
    staleTime: 15_000,
  })
}

export function useQueueQuarantineSourceQueues(options?: { enabled?: boolean }) {
  const { currentEnv } = useNetworkEnvironment()
  return useQuery({
    queryKey: queueQuarantineQueryKeys.sourceQueues(currentEnv),
    queryFn: () => monitoringService.getQueueQuarantineSourceQueues(currentEnv),
    enabled: options?.enabled ?? true,
    staleTime: 15_000,
  })
}
